import { BrowserRouter, Route } from 'react-router';
import { ApolloProvider } from '@apollo/client/react';
import { LoginCallback } from '@okta/okta-react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';

import config from 'config';
import apolloClient from 'apollo/client';

import DashboardLayout from 'layouts/DashboardLayout/DashboardLayout';

import ThemeProvider from 'providers/ThemeProvider/ThemeProvider';
import AgentProvider from 'providers/AgentProvider';
import AgentSettingsProvider from 'providers/AgentSettingsProvider';
import AWSConnectProvider from 'providers/AWSConnectProvider';
import CustomerInfoProvider from 'providers/CustomerInfoProvider';
import OktaAuthenticationProvider from 'providers/OktaAuthenticationProvider';
import RequireAuth from 'providers/RequireAuth';
import StylesProvider from 'providers/StylesProvider';
import SegmentProvider from 'providers/SegmentProvider';
import TranslationProvider from 'providers/TranslationProvider';

import { SentryRoutes } from 'services/sentry';

const AppWithProviders = () => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <StylesProvider>
          <OktaAuthenticationProvider>
            <AgentProvider>
              <SegmentProvider>
                <AgentSettingsProvider>
                  <ApolloProvider client={apolloClient}>
                    <AWSConnectProvider>
                      <CustomerInfoProvider>
                        <TranslationProvider>
                          <SentryRoutes>
                            <Route
                              path="/login/callback"
                              element={<LoginCallback />}
                            />
                            <Route element={<RequireAuth />}>
                              <Route path="/*" element={<DashboardLayout />} />
                            </Route>
                          </SentryRoutes>
                        </TranslationProvider>
                      </CustomerInfoProvider>
                    </AWSConnectProvider>
                  </ApolloProvider>
                </AgentSettingsProvider>
              </SegmentProvider>
            </AgentProvider>
          </OktaAuthenticationProvider>
        </StylesProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default withLDProvider({
  clientSideID: `${config.LAUNCH_DARKLY_CLIENT_ID}`,
  context: {
    anonymous: true,
    kind: 'user',
    key: 'anonymous',
  },
  options: {
    streaming: true,
    logger: {
      // Comment this dummy logger object to debug launch darkly
      debug: () => {},
      error: () => {},
      info: () => {},
      warn: () => {},
    },
  },
})(AppWithProviders);
